module.exports = __webpack_public_path__ + "static/img/the_impostor.c21379e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AmongUs/the_impostor.png
// module id = kyAP
// module chunks = 1